export default "__VITE_ASSET__846eb4a0__$_?nuxt_component=async__"